<app-navbar appHideTitle></app-navbar>


<div class="banner-area banner-img-one">
    <div class="box-arrange yellow-box">
        <h2 class="custom-section-title">AgribusinessJob - Staff</h2>
        <p [innerHTML]="'HOMEPAGE.HTML_STAFF' | translate"></p>
        <a routerLink="/abj-staff">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
    </div>

    <div class="box-arrange blue-box">
        <h2 class="custom-section-title">AgribusinessJob - Specialist</h2>
        <p [innerHTML]="'HOMEPAGE.HTML_SPECIALIST' | translate"></p>
        <a routerLink="/abj-specialisti">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
    </div>

    <div class="box-arrange green-box">
        <h2 class="custom-section-title">AgribusinessJob - Junior</h2>
        <p [innerHTML]="'HOMEPAGE.HTML_JUNIOR' | translate"></p>
        <a routerLink="/abj-juniori">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
    </div>
</div>


<section class="category-area ptb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2 class="custom-section-title">{{'HOMEPAGE.EMPLOYEE_SEARCH.TITLE' | translate}}</h2>
            <p class="custom-subtitle" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.SUBTITLE_HTML' | translate"></p>
        </div>

        <div class="d-flex flex-wrap justify-content-between pb-16">
            <div>
                <div class="category-item d-flex category-one">
                    <div>
                        <i class="icofont-briefcase-2"></i>
                    </div>
                    <a routerLink="/inregistrare" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.POST_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-two d-flex">
                    <div>
                        <i class="icofont-people"></i>
                    </div>
                    <a routerLink="/agentie-de-recrutare" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.RECRUITING_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-three d-flex">
                    <div>
                        <i class="icofont-autism"></i>
                    </div>
                    <a routerLink="/evaluare-personalitate" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.PERSONALITY_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-four d-flex">
                    <div>
                        <i class="icofont-brainstorming"></i>
                    </div>
                    <a routerLink="/" (click)="scroll(cunostinte)" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.E_LEARNING_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-one d-flex">
                    <div>
                        <i class="icofont-company"></i>
                    </div>
                    <a href="https://testeabj.nexloc.com" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.KNOWLEDGE_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-five d-flex">
                    <div>
                        <i class="icofont-chart-arrows-axis"></i>
                    </div>
                    <a routerLink="/" (click)="scroll(piata)" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.RESEARCH_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-six d-flex">
                    <div>
                        <i class="icofont-money-bag"></i>
                    </div>
                    <a routerLink="/comparator-salarii" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.INCOME_HTML' | translate"></a>
                </div>
            </div>

            <div>
                <div class="category-item category-seven d-flex">
                    <div>
                        <i class="icofont-badge"></i>
                    </div>
                    <a routerLink="/agribusiness-staff" [innerHTML]="'HOMEPAGE.EMPLOYEE_SEARCH.QUALITY_HTML' | translate"></a>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <a class="green-button" routerLink="/inregistrare">{{'HOMEPAGE.EMPLOYEE_SEARCH.BUTTON' | translate}}</a>
        </div>
    </div>
</section>

<div class="homepage-job-banner banner-area pb-25">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="banner-text">
                    <h1>{{'HOMEPAGE.CARREAR_IMPROVMENT.TITLE' | translate}}</h1>
                    <p>{{'HOMEPAGE.CARREAR_IMPROVMENT.SUBTITLE' | translate}}</p>

                    <div class="banner-form-area">
                        <form #searchForm="ngForm">
                            <div class="row d-flex align-items-center">
                                <div class="col-lg-2 mb-5 col-12">
                                    <div class="form-group">
                                        <label><i class="icofont-search-1"></i></label>
                                        <input type="text" class="form-control" placeholder="{{'HOMEPAGE.CARREAR_IMPROVMENT.NAME' | translate}}" [(ngModel)]="jobTitle">
                                    </div>
                                </div>

                                <div class="col-lg-2 mb-5 col-12">
                                    <div class="form-group">
                                        <label *ngIf="!isDomainChanged" for="dom" class="label-subdom">{{'HOMEPAGE.CARREAR_IMPROVMENT.DOMAIN' | translate}}</label>
                                                <select [(ngModel)]="selectedDomain"
                                                        (change)="changeDomain($event)"
                                                        class="form-control"
                                                        name="activitySector"
                                                        required
                                                        id="dom"
                                                        #domainController="ngModel">
                                                        <option *ngFor="let country of Domains">{{country.name}}</option>
                                                </select>
                                    </div>
                                </div>

                                <div class="col-lg-2 mb-5 col-12">
                                    <div class="form-group">
                                        <label *ngIf="!selectedDomain" for="subdom" class="label-subdom">{{'HOMEPAGE.CARREAR_IMPROVMENT.SUBDOMAIN' | translate}}</label>
                                        <select
                                        [(ngModel)]="selectSubdomains"
                                        class="form-control"
                                        name="activitySubSector"
                                        id="subdom"
                                        required
                                        #subdomainController="ngModel"
                                        >
                                       <option *ngFor="let subdomain of subDomainsArray">{{subdomain}}</option>
                                        </select>
                                        <!-- <ng-select2
                                                [(ngModel)]="selectSubdomains"
                                                [data]="subDomainsArray"
                                                [options]="singleOption"
                                                (valueChanged)="changeSubDomain($event)"
                                               placeholder="Subdomeniu"
                                        >
                                        </ng-select2> -->
                                    </div>
                                </div>

                                <div class="col-lg-2 mb-5 col-12">
                                    <div class="form-group">
                                        <select
                                        [(ngModel)]="selectedDepartments"
                                        class="form-control"
                                        name="departments"
                                        required
                                        #departmentController="ngModel"
                                        >
                                       <option value="" disabled selected>{{'HOMEPAGE.CARREAR_IMPROVMENT.DEPARTMENT' | translate}}</option>
                                       <option *ngFor="let department of departments">{{department}}</option>
                                        </select>
                                        <!-- <ng-select2 [data]="departments"
                                                    [options]="multiOptions"
                                                    [(ngModel)]="selectedDepartments"
                                                   placeholder="Departament"
                                        >
                                        </ng-select2> -->
                                    </div>
                                </div>

                                <div class="col-lg-2 mb-5 col-12">
                                    <div class="form-group">
                                        <label for="loc" *ngIf="!city" class="label-subdom"><i class="icofont-location-pin"></i>{{'HOMEPAGE.CARREAR_IMPROVMENT.CITY' | translate}}</label>
                                        <!-- <input type="text" class="form-control" placeholder="Localitatea" [(ngModel)]="city"> -->
                                       <select
                                       [(ngModel)]="city"
                                        class="form-control"
                                        name="city"
                                        id="loc"
                                        required
                                        #cityController="ngModel">
                                        <option *ngFor="let city of loc">{{city}}</option>
                                       </select>
                                    </div>
                                </div>
                                <div class="col-lg-2 mb-5 col-12">
                                    <button routerLink="/joburi" [queryParams]="{denumire: jobTitle, domeniu: selectedDomain, subdomeniu: selectSubdomains, departamente:selectedDepartments, localitate: city}" class="btn white-button" (click)="findJob()">{{'HOMEPAGE.CARREAR_IMPROVMENT.BUTTON' | translate}}</button>
                                </div>

                            </div>

                        </form>
                    </div>

                    <!--                    <div class="plain-buttons-row mt-10">-->
                    <!--                        <a routerLink="/create-account"><i class="icofont-upload-alt"></i> Urcă CV-ul tău</a>-->
                    <!--                        <a routerLink="/submit-resume"><i class="icofont-briefcase-2"></i> Angajezi? Postează postul</a>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="homepage-about-agri ptb-100">
    <div class="container-fluid overflow-hidden">
        <div class="row align-items-center">
            <div class="col-lg-2 col-md-6 logo-img-wrapper text-center">
                <img src="/assets/img/home-1/logo-agri.png">
            </div>
            <div class="col-lg-4 col-md-6">
                <h2>{{'HOMEPAGE.ABOUT_AGRI.TITLE' | translate}}</h2>
                <p [innerHTML]="'HOMEPAGE.ABOUT_AGRI.SUBTITLE_HTML' | translate"></p>
                <div class="empty-row-45"></div>
                <a class="green-button" routerLink="/abj-despre">{{'HOMEPAGE.ABOUT_AGRI.BUTTON' | translate}}</a>
            </div>
            <div class="col-lg-6 text-right img-right">
                <img src="/assets/img/home-1/about-agribusiness.png"/>
            </div>
        </div>
    </div>
</div>

<section class="job-area ptb-100 light-grey-background">
    <div class="container">
        <div class="section-title">
            <h2>{{'HOMEPAGE.BEST_EMPLOYERS.TITLE' | translate}}</h2>
            <p>{{'HOMEPAGE.BEST_EMPLOYERS.SUBTITLE' | translate}}</p>
        </div>
        <div id="container">
            <div class="row pb-50 justify-content-center">
                <div class="col-lg-4 job-home-container mb-16"  *ngFor="let job of homeLastJobs" [routerLink]="['/job/'+ job.id]">
                    <div class="d-flex flex-column job-bg">
                        <div class="d-flex justify-content-between mb-5">
                            <div class="job-type">{{job.workType[0] | enumTransform}}</div>
                            <div class="job-date">{{job.jobPostingDate | date:'mediumDate'}}</div>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center">
                            <div class="job-img-container mb-5">
                            <img class="job-image" src="{{job.photoPath}}" alt="Job">
                            </div>
                            <h5 class="job-title">{{job.jobTitle}}</h5>
                            <p class="job-location"><i class="icofont-location-pin"></i> {{job.country}} - {{job.city | slice:0:3}} ...</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <a class="green-button" routerLink="/joburi">{{'HOMEPAGE.BEST_EMPLOYERS.BUTTON' | translate}}</a>
            </div>
        </div>
    </div>
</section>

<div class="homepage-about-agri ptb-100 random-post" *ngFor=" let post of randomPost">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2>{{'HOMEPAGE.AGRI_NEWS.TITLE' | translate}}</h2>
                <p>{{'HOMEPAGE.AGRI_NEWS.SUBTITLE' | translate}}</p>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-2 rotate-text">
                <img src="/assets/img/home-1/HR-AGRIFOOD.png"/>
            </div>
            <div class="col-lg-4">
                <h2>{{post.title}}</h2>
                <div class="d-flex post-info">
                    <div class="post-date">
                        <i class="icofont-ui-calendar"></i> {{post.postingDate | date:'dd-MM-yyyy HH:mm'}}
                    </div>
                    <div class="post-reading-time">
                        <i class="icofont-user icon-style"></i>{{post.userName}}
                    </div>
                </div>
                <p>{{post.summary}}</p>
                <div class="empty-row-45"></div>
                <a class="green-button" routerLink="/vezi-articol/{{post.id}}">{{'HOMEPAGE.AGRI_NEWS.BUTTON' | translate}}</a>
            </div>
            <div class="col-lg-6 random-blog-photo">
                <img class="img-resize" src="{{post.photoPath}}"/>
            </div>
        </div>
    </div>
</div>

<div class="job-categories ptb-100 light-grey-background">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2>{{'HOMEPAGE.JOB_SEARCH.TITLE' | translate}}</h2>
                <p [innerHTML]="'HOMEPAGE.JOB_SEARCH.SUBTITLE_HTML' | translate"></p>
            </div>
        </div>
        <div class="empty-row-70"></div>
        <div class="row">
            <div class="col text-center">
                <i class="icofont-tractor job-cat-img"></i>
                <h3 class="job-cat-title">Agricultura</h3>
                <p class="jobs-count">({{agriJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
            </div>
            <div class="col text-center">
                <i class="icofont-cabbage job-cat-img"></i>
                <h3 class="job-cat-title">Horticultura</h3>
                <p class="jobs-count">({{hortiJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
            </div>
            <div class="col text-center">
                <i class="icofont-cow job-cat-img"></i>
                <h3 class="job-cat-title">Zootehnie</h3>
                <p class="jobs-count">({{zooJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
            </div>
            <div class="col text-center">
                <i class="icofont-injection-syringe job-cat-img"></i>
                <h3 class="job-cat-title">Medicina veterinara</h3>
                <p class="jobs-count">({{medicVetJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
            </div>
            <div class="col text-center">
                <i class="icofont-bread job-cat-img"></i>
                <h3 class="job-cat-title">Industria alimentara</h3>
                <p class="jobs-count">({{alimentsJobs}} {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
            </div>
        </div>
        <div class="empty-row-70"></div>
        <div class="row justify-content-center">
            <a class="green-button" routerLink="/joburi">{{'HOMEPAGE.JOB_SEARCH.BUTTON' | translate}}</a>
        </div>
    </div>
</div>

<div class="info-area pt-100 white-background">
    <div class="container text-center">
        <h2>{{'HOMEPAGE.CARREAR_STUDY.TITLE' | translate}}</h2>
    </div>
    <div class="empty-row-45"></div>
    <div class="container-fluid overflow-hidden">
        <div class="row info-row pt-100 info-row-1">
            <div class="container">
                <div class="info-block col-md-7">
                    <h3>{{'HOMEPAGE.CARREAR_STUDY.SUBTITLE1' | translate}}</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.CARREAR_STUDY.TEXT1_HTML' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a href="https://testeabj.nexloc.com/" target="_blank" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 info-row-2">
            <div class="container">
                <div class="info-block col-md-7 offset-md-5">
                    <h3>{{'HOMEPAGE.CARREAR_STUDY.SUBTITLE2' | translate}}</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.CARREAR_STUDY.TEXT2_HTML' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/evaluare-personalitate" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 pb-100 info-row-3" #cunostinte>
            <div class="container" >
                <div class="info-block col-md-7">
                    <h3>{{'HOMEPAGE.CARREAR_STUDY.SUBTITLE3' | translate}}</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.CARREAR_STUDY.TEXT3_HTML' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a target="_blank" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS_SOON' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 pb-100 info-row-4">
            <div class="container">
                <div class="info-block col-md-7 offset-md-5">
                    <h3>{{'HOMEPAGE.CARREAR_STUDY.SUBTITLE4' | translate}}</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.CARREAR_STUDY.TEXT4_HTML' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/comparator-salarii" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 pb-100 info-row-5" #piata>
            <div class="container">
                <div class="info-block col-md-7">
                    <h3>{{'HOMEPAGE.CARREAR_STUDY.SUBTITLE5' | translate}}</h3>
                    <div class="empty-row-30"></div>
                    <p [innerHTML]="'HOMEPAGE.CARREAR_STUDY.TEXT5_HTML' | translate"></p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/contact" class="simple-text-button">{{'HOMEPAGE.STUDY' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="partners-area ptb-100 dark-grey-background">
    <div class="container">
        <div class="section-title">
            <h2>{{'HOMEPAGE.AGRI_PARTNERS.TITLE' | translate}}</h2>
        </div>
        <div class="empty-row-30"></div>

        <div class="partners-slider owl-theme owl-carousel">
            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://frizongroup.ro/ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/Frizon 2.png" alt="Frizon">Frizon
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://dicorland.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/Dicorland.png" alt="Frizon">Dicorland
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.carpathia.org/ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/carpathia.png" alt="Frizon">Carpathia
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.ipso.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/ipso.png" alt="Frizon">Ipso
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.isagri.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/isagri.png" alt="Frizon">Isagri
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://naandanjain.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/naandanjain.png" alt="Frizon">NaanDanJain
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://mecanicaceahlau.ro/#" target="_blank">
                    <img src="../../../assets/img/home-1/partners/mecanicaceahlau.png" alt="Frizon">Mecanica Ceahlau
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.masseeds.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/masseeds 2.png" alt="Frizon">MAS Seeds
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.soufflet-agro.ro/ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/soufflet-agro.png" alt="Frizon">Soufflet Agro
                </a>
            </div>            

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://biochemorganics.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/biochemorganics.png" alt="Frizon">Biochem Organics
                </a>
            </div>            

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.dsm.com/corporate/home.html" target="_blank">
                    <img src="../../../assets/img/home-1/partners/dsm.png" alt="Frizon">DSM
                </a>
            </div>       

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.farmavet.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/farmavet.png" alt="Frizon">Farmavet
                </a>
            </div>    

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.bejo.ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/bejo.png" alt="Frizon">Bejo
                </a>
            </div>

            <div class="partners-item item">
                <a class="d-flex align-items-center flex-column" href="https://www.indagra.ro/ro/" target="_blank">
                    <img src="../../../assets/img/home-1/partners/indagra.png" alt="Frizon">Indagra
                </a>
            </div>

        </div>
    </div>
</section>

<section>
    <div class="banner-container">
        <a class="img-wrapper-banner" href="https://agritradesummit.ro/" target="_blank"></a>
    </div>
</section>

<div class="numbers-area white-background pt-100">
    <div class="container">
        <div class="container text-center">
            <h2 class="custom-section-title">{{'HOMEPAGE.AGRI_JOBS.TITLE' | translate}}</h2>
            <p>{{'HOMEPAGE.AGRI_JOBS.SUBTITLE' | translate}}</p>
        </div>
        <div class="row mt-20">
            <!-- <div class="col-sm-3 col-6">
                <div class="counter-item">
                    <img src="assets/img/home-1/icon-candidates.png">
                    <h3 class="custom-section-title"><span class="counter">TBD</span></h3>
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.CANDIDATE_HTML' | translate"></p>
                </div>
            </div> -->

            <div class="col-sm-4 col-6">
                <div class="counter-item">
                    <img src="assets/img/home-1/icon-jobs.png">
                    <h3 class="custom-section-title"><span class="counter">{{availableJObs}}</span></h3>
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.JOB_NUMBER_HTML' | translate"></p>
                </div>
            </div>

            <div class="col-sm-4 col-6">
                <div class="counter-item">
                    <img src="assets/img/home-1/icon-companies.png">
                    <h3 class="custom-section-title"><span class="counter">{{availableCompanies}}</span></h3>
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.EMPOYERS_HTML' | translate"></p>
                </div>
            </div>

            <div class="col-sm-4 col-6">
                <div class="counter-item">
                    <img src="assets/img/home-1/icon-years.png">
                    <h3 class="custom-section-title"><span class="counter">{{yearsOfActivity}}</span></h3>
                    <p [innerHTML]="'HOMEPAGE.AGRI_JOBS.EXPERIANCE_HTML' | translate"></p>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
